/* eslint-disable perfectionist/sort-objects */
export const URL = {
  LOGIN: `users/login`,
  LOGOUT: `users/logout`,
  REFRESH: `users/refresh`,
  USERS: 'users',
  USER_DETAILS: 'users/:id',
  USER_ROLES: 'users/roles',
  USER_UPDATE_PASSWORD: 'users/:id/update-password',
  USER_SEND_RESET_PASSWORD: 'users/send-reset-password',
  USER_RESET_PASSWORD: 'users/reset-password',
  USER_VALIDATE_RESET_TOKEN: 'users/validate-reset-token',
  USER_APPROVAL_PASSWORD: 'users/:id/approval-password',
  USER_VERIFY_APPROVAL_PASSWORD: 'users/:id/verify-approval-password',
  USER_CHANGE_EMAIL: 'users/:id/email-change/request',
  USER_VERIFY_CHANGE_EMAIL_CODE: 'users/:id/email-change/confirm',

  COMPANY_LIST: 'company',
  COMPANY_DETAILS: 'company/:id',
  MY_COMPANY_INFO: 'company/my-company',
  UPDATE_COMPANY_SETTINGS: 'company/:id/settings',
  COMPANY_PAYROLL_SETTINGS: 'company/:id/payroll-settings',

  EVENT_LIST: 'events',
  EVENT_DETAILS: 'events/:id',
  EVENT_OFFER: 'events/:id/offer',
  EVENT_ACCEPT: 'events/:id/accept',
  EVENT_REPORT: 'events/:id/report',
  EVENT_CHECKOUT: 'events/:id/checkout',
  EVENT_EMPLOYEES: 'events/:id/employees',
  EVENT_INVENTORY_STATISTIC: 'events/:id/inventory',
  EVENT_REPORT_PDF: 'events/:id/report-pdf',
  EVENT_CLOSE_DAY: 'events/:id/open-close-day',
  EVENT_CASH_MANAGER: 'events/:id/cash-manager',
  EVENT_QUESTIONNAIRE: 'events/:id/questionnaire',
  EVENT_GET_QUESTIONNAIRE: 'events/questionnaire/:id',
  EVENT_GET_QUESTIONNAIRES: 'events/questionnaires',
  EVENT_RECEIPTS: 'events/:id/receipts',
  EVENT_RECEIPTS_HTML: 'events/:id/receipt/:receiptId/html',
  EVENT_RECEIPT: 'events/:id/receipt/:receiptId',
  EVENT_EMPLOYEE_CHECKOUTS: 'events/:id/employee-checkouts',
  EVENT_GET_TAX_RATE: 'events/tax-rate',
  EVENT_TOP_SELLERS: 'events/top-sellers',
  EVENT_DASHBOARD_STATISTICS: 'events/:id/dashboard-statistics',
  EVENT_EMPLOYEE_COMMISSIONS: 'events/:id/employee-commissions/:userId',
  EVENT_PROFIT_AND_LOSSES: 'events/:id/profit-loss',
  EVENT_STOCK_ORDERS_INFO: 'events/:id/stock-orders-info',
  EVENT_TOTAL_SALES: 'events/total-sales-for-events',
  EMPLOYEE_EVENTS: 'events/employee-events/:id',
  GET_VOIDED_CHECKOUTS_FOR_USER: 'events/employee-voided/:id',
  GET_TOP_EVENTS: 'events/top-events',
  EVENT_CREATE_SHIPPING: 'events/:id/create-shipping',

  CUSTOMERS_LIST: 'customers',
  CUSTOMER_DETAILS: 'customers/:id',
  CUSTOMER_CHECKOUTS: 'customers/checkouts/:id',

  PRODUCT_TYPES: 'product-types',

  PAYMENT_METHODS: 'payment-methods',
  PAYMENT_METHOD: 'payment-methods/:id',
  PAYMENT_METHODS_ORDER: 'payment-methods/order',

  PRODUCT_LIST: 'products',
  PRODUCT_DETAILS: 'products/:id',

  SUPPLIER_LIST: 'suppliers',
  SUPPLIER_DETAILS: 'suppliers/:id',

  CART: 'cart/event/:id',
  CART_DUPLICATE_CARD_CHECK: 'cart/event/:id/duplicate-card-check',
  CART_RESET: 'cart/event/:id/reset',
  CART_ADD: 'cart/event/:id/cartItem',
  UNLOCK_CARTS: 'cart/unlock-carts/:userId',
  CART_UPDATE: 'cart/event/:id/cartItem/:cartItemId',
  CART_REMOVE_ITEM: 'cart/event/:id/cartItem/:cartId',

  CATEGORIES: 'categories',
  CATEGORY_DETAILS: 'categories/:id',

  STORAGES: 'storages',
  STORAGE: 'storages/:id',
  STORAGE_MONTHLY_PAID: 'storages/monthly-paid/:id',

  EMPLOYEES: 'employees',
  EMPLOYEE: 'employees/:id',
  EMPLOYEE_ME: 'employees/me',
  EMPLOYEE_DEACTIVATE: 'employees/:id/deactivate',
  EMPLOYEE_REACTIVATE: 'employees/:id/reactivate',

  DEALS: 'deals',
  DEAL: 'deals/:id',

  ATTRIBUTES: 'attributes',
  ATTRIBUTE: 'attributes/:id',

  APPOINTMENTS: 'appointment',
  APPOINTMENT: 'appointment/:id',

  STORAGE_INVENTORY: 'inventory/storage/:id',
  STORAGE_INVENTORY_DETAILS: 'inventory/storage/:id/:inventoryId',

  THEMES: 'themes',

  STOCK_ORDERS: 'inventory/stockorder',
  STOCK_ORDER: 'inventory/stockorder/:id',
  STOCK_ORDER_COMPLETE: 'inventory/stockorder/:id/done',
  // L4a: LTL invoice # / price only, any status (Company Owner + Administrative)
  STOCK_ORDER_LTL: 'inventory/stockorder/:id/ltl',

  GET_SALES_INFO: 'sales/info',
  GET_DEVICES: 'settings/devices',
  GET_INTEGRATIONS: 'settings/integrations',

  STOCK_TRANSFERS: 'inventory/transfer',
  STOCK_TRANSFER: 'inventory/transfer/:id',
  STOCK_TRANSFER_COMPLETE: 'inventory/transfer/:id/complete',
  STOCK_TRANSFER_ACCEPT: 'inventory/transfer/:id/accept',
  // L4a: LTL invoice # / price only, any status (Company Owner + Administrative)
  STOCK_TRANSFER_LTL: 'inventory/transfer/:id/ltl',

  GET_PAYOUTS: 'payouts/payoutItem',
  CREATE_PAYROLL: 'payouts/payout',
  DELETE_PAYROLL: 'payouts/payout/:id',
  UPDATE_PAYOUT: 'payouts/payoutItem/:id',
  GET_PAYOUT_HISTORY: 'payouts/payout/employee/:id',
  GET_PENDING_PAYOUTS: 'payouts/payout/pending/:id',
  GET_PAYOUT_DETAILS: 'payouts/payoutItem/:id/details',
  CHANGE_PAYOUT_STATUS: 'payouts/payoutItem/:id/status',
  GET_EMPLOYEE_SALARY: 'payouts/:id/salary',

  UPLOAD_FILE: 'upload-file',

  CARRIERS: 'carriers',

  GET_ANALYTICS: 'analytics',
  GET_ANALYTICS_EMPLOYEE: 'analytics/employee/:id',
  GET_ANALYTICS_CHECKOUT_EDIT: 'analytics/checkout/:id',

  EVENT_ORDERS: 'event-orders',
  EVENT_ORDER: 'event-orders/:id',
  EVENT_ORDERS_CSV: 'event-orders/csv',
  EVENT_ORDER_CHANGE_STATUS: 'event-orders/:id/change-status',
  EVENT_ORDER_TRACKING_NUMBER: 'event-orders/:id/tracking-number',

  PRICE_APPROVAL: 'price-approval',
  PRICE_APPROVAL_DETAILS: 'price-approval/:id',
  PRICE_APPROVAL_CHANGE_STATUS: 'price-approval/:id/status',
  PRICE_APPROVAL_APPROVE: 'price-approval/approve',
  PRICE_APPROVAL_CART_PRODUCTS: 'price-approval/approve-cart-products',

  GET_ACCOUNTING_EXPENSES: 'accounting/expenses',
  GET_ACCOUNTING_EXPENSE_PAGE: 'accounting/expenses/page',
  GET_ACCOUNTING_EXPENSE_FILTER_OPTIONS: 'accounting/expenses/filter-options',
  CREATE_ACCOUNTING_EXPENSE: 'accounting/expense',
  GET_ACCOUNTING_EXPENSE: 'accounting/expense/:id',

  GET_ACCOUNTING_COMPANY_EXPENSES: 'accounting/company-expenses',

  CREATE_ACCOUNTING_CATEGORY: 'accounting/category',
  GET_ACCOUNTING_CATEGORIES: 'accounting/categories',
  GET_ACCOUNTING_CATEGORY: 'accounting/category/:id',

  GET_CHARGEBACKS: 'accounting/chargebacks',
  UPDATE_CHARGEBACK: 'accounting/chargebacks/:id',
  GET_CHARGEBACK_DETAILS: 'accounting/chargeback/:id',
  GET_CHARGEBACKS_OVERVIEW: 'accounting/chargebacks/overview',
  MARK_CHARGEBACK_VIEWED: 'accounting/chargeback/:id/mark-viewed',
  UPDATE_CHARGEBACK_STATUS: 'accounting/chargebacks/:id/status',

  GET_MONTHLY_TAXES: 'accounting/monthly-taxes',
  UPDATE_MONTHLY_TAX: 'accounting/monthly-taxes/:month/:year',

  GET_ACCOUNTING_TRANSACTIONS: 'accounting/transactions',
  ACCOUNTING_MARK_DISPUTE: 'accounting/transactions/dispute/:id',

  GET_ACCOUNTING_EXPENSES_CATEGORIES: 'accounting/expenses/categories',

  GET_ACCOUNTING_DEPOSITS: 'accounting/deposits',

  GET_ACCOUNTING_SALES: 'accounting/sales',

  GET_ACCOUNTING_CHARGEBACKS: 'accounting/chargebacks',

  GET_ACCOUNTING_GIFT_CARDS: 'accounting/gift-cards',

  GET_ACCOUNTING_TAVLA_SUMMARY: 'accounting/tavla/summary',
  GET_ACCOUNTING_TAVLA_PAYMENTS: 'accounting/tavla/payments',
  GET_ACCOUNTING_TAVLA_BACK_OFFICE: 'accounting/tavla/back-office',
  GET_ACCOUNTING_TAVLA_TRANSACTIONS: 'accounting/tavla/transactions',

  GET_ACCOUNTING_REVENUE_CREDIT: 'accounting/revenue/credit',
  GET_ACCOUNTING_REVENUE_SUMMARY: 'accounting/revenue/summary',
  GET_ACCOUNTING_REVENUE_DEPOSITS: 'accounting/revenue/deposits',

  GET_ACCOUNTING_SALES_TAX: 'accounting/taxes',
  GET_ACCOUNTING_SALES_TAX_SUMMARY: 'accounting/sales-tax/summary',

  GET_ACCOUNTING_PROFIT_LOSSES: 'accounting/profit-losses',

  SEND_REFUND_MAIL: 'mailer/refund',
  SEND_CHECKOUT_MAIL: 'mailer/checkout',

  GET_COMMISSION_SETS: 'commission-level',
  UPDATE_COMMISSION_SET: 'commission-level/:id',
  GET_DAILY_EMPLOYEE_COMMISSION_LEVEL: 'commission-level/employee/:id',

  EVENT_EXPENSES: 'event-expenses',
  EVENT_EXPENSE_DETAILS: 'event-expenses/:id',

  GET_REFUNDS: 'refund',
  CREATE_REFUND: 'refund/:id',
  GET_EMPLOYEE_REFUNDS: 'refund/employee/:id',
  GET_REFUND_RECEIPT_HTML: 'refund/:id/html',

  CREATE_EXCHANGE: 'exchange/:id',
  GET_EMPLOYEE_EXCHANGE: 'exchange/employee/:id',

  CLOVER_DISPLAY_ORDER: 'clover/display-order/:id',
  CLOVER_MAKE_SALE: 'clover/make-sale',
  CLOVER_INITIATE_PAYMENT: 'clover/payment',
  CLOVER_PAYMENT_STATUS: 'clover/payment/status/:intentId',
  CLOVER_CANCEL_PAYMENT: 'clover/payment/cancel/:intentId',
  CLOVER_RESET_DEVICE: 'clover/reset-device',
  CLOVER_PRINT_RECEIPT: 'clover/print-receipt',
  CLOVER_CANCEL_ACTION: 'clover/cancel-action',
  CLOVER_DISPLAY_MESSAGE: 'clover/display-message',
  CLOVER_DISPLAY_WELCOME: 'clover/display-welcome',
  CLOVER_SIGNATURE: 'clover/signature',
  CLOVER_DISPLAY_THANKS: 'clover/display-thanks',
  CLOVER_VERIFY_DEVICE_CONNECT: 'clover/verify-device-connect',
  CLOVER_REQUEST_TIP: 'clover/tip',
  CLOVER_TOKEN_INFO: 'clover/token-info',
  CLOVER_VOID_PAYMENT: 'clover/void-payment/:checkoutId',
  VOID_CLOVER_PAYMENT: 'clover/void-clover-payment/:paymentId',
  CLOVER_ADD_TOKEN: 'clover/add-token',
  CLOVER_UPDATE_TOKEN: 'clover/update-token',
  CLOVER_GET_ECOMMERCE_TOKEN: 'clover/token-ecommerce',
  CLOVER_ADD_ECOMMERCE_TOKEN: 'clover/add-token-ecommerce',
  CLOVER_UPDATE_ECOMMERCE_TOKEN: 'clover/update-token-ecommerce',
  CLOVER_PRINT_PAYMENT_RECEIPT: 'clover/print-receipt/:checkoutId',

  GET_CLOVER_DEVICES: 'clover-device',
  GET_CLOVER_DEVICE: 'clover-device/:id',

  GET_FEATURES: 'features',
  GET_FEATURES_BY_ROLES: 'features/:id/features-by-role',
  GET_ROLES_BY_FEATURE: 'features/roles-by-features',
  UPDATE_ROLE_FEATURES: 'features/:id/update-role-features',
  UPDATE_ROLES_FEATURES: 'features/update-features-for-roles',

  GET_NOTIFICATIONS: 'notifications',
  GET_NOTIFICATIONS_SETTINGS: 'notifications/settings',
  SAVE_NOTIFICATIONS_SETTINGS: 'notifications/settings',
  MARK_AS_READ_NOTIFICATION: 'notifications/:id/read',
  MARK_ALL_AS_READ_NOTIFICATIONS: 'notifications/mark-all-read',

  GET_RECEIPT_SETTINGS: 'receipt-settings',
  GET_RECEIPT_SETTING: 'receipt-settings/:id',

  SHIP_STATION_CONFIG: 'ship-station/config',
  SHIP_STATION_STORES: 'ship-station/stores',
  SHIP_STATION_SYNC_ORDERS: 'ship-station/sync-orders',
  SHIP_STATION_RESEND_NOTIFICATIONS: 'ship-station/:id/resend-notifications',

  GET_SHIPPING_TIERS: 'shipping-tier',
  GET_SHIPPING_COST: 'shipping-tier/cost',
  UPDATE_SHIPPING_TIER: 'shipping-tier/:id',

  GET_FISERV_TOKEN: 'fiserv/token',
  GET_FISERV_CASE_DETAILS: 'fiserv/case-detail/:id',
  GET_FISERV_RETURNS_REPORT: 'fiserv/returns-report',
  GET_FISERV_RETRIEVALS_DETAIL: 'fiserv/retrievals-detail',
  GET_FISERV_RETRIEVALS: 'fiserv/retrievals',
  GET_FISERV_RETRIEVALS_SUMMARY: 'fiserv/retrievals-summary',
  UPDATE_FISERV_RETRIEVAL: 'fiserv/retrieval/:id',
  GET_FISERV_RETRIEVAL: 'fiserv/retrievals/:id',
  GET_FISERV_PAYMENT_DETAIL: 'fiserv/payment-detail',
  GET_FISERV_FUNDING_GROUPS: 'fiserv/funding-groups',
  GET_FISERV_BATCH_DETAIL: 'fiserv/batch-detail',
  GET_FISERV_DEPOSIT_REPORTING_READINESS: 'fiserv/deposit-reporting/readiness',
  GET_FISERV_DEPOSIT_REPORTING_PAYMENT_SUMMARY:
    'fiserv/deposit-reporting/payment-summary-by-merchant',
  GET_FISERV_BATCH_SUMMARY_BY_MERCHANT: 'fiserv/batch-summary-by-merchant',
  GET_FISERV_PAYMENT_SUMMARY_BY_MERCHANT: 'fiserv/payment-summary-by-merchant',
};
